
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/pricing",
      function () {
        return require("private-next-pages/site/pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/pricing"])
      });
    }
  